import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=6520247b"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports